import React from "react";
import {
  FileText,
  User,
  FileEdit,
  Star,
  BarChart3,
  Ruler,
  Briefcase,
  Users,
  BarChart,
  Shield,
  Building,
} from "lucide-react";

interface Module {
  id: string;
  label: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const modules: Module[] = [
  { id: "topics", label: "Đề tài, nhiệm vụ KH&CN", icon: FileText },
  { id: "cooperation", label: "Hợp tác quốc tế", icon: Building },
  { id: "profile", label: "Lý lịch khoa học", icon: User },
  { id: "articles", label: "Bài báo - Công trình KH", icon: FileEdit },

  { id: "awards", label: "Khen thưởng", icon: Star },
  { id: "equipment", label: "Trang thiết bị", icon: BarChart3 },
  { id: "standards", label: "Tiêu chuẩn", icon: Ruler },
  { id: "services", label: "Dịch vụ KHCN", icon: Briefcase },

  { id: "intellectual", label: "Các sản phẩm sở hữu trí tuệ", icon: Briefcase },
  { id: "council", label: "Hội đồng", icon: Users },
  { id: "experts", label: "Chuyên gia", icon: Users },
  { id: "documents", label: "Văn bản - Tài liệu", icon: FileText },

  { id: "reports", label: "Báo cáo - Thống kê", icon: BarChart },
  { id: "members", label: "Thành viên", icon: Users },
  { id: "update", label: "Cập nhật thông tin", icon: Shield },
];

// Icon bubble co giãn nhẹ để vẫn hợp trên màn nhỏ
const IconBubble: React.FC<{ Icon: Module["icon"] }> = ({ Icon }) => (
  <div
    className="rounded-[24px] flex items-center justify-center ring-1 ring-emerald-900/15"
    style={{
      width: "clamp(40px, 6vw, 56px)",
      height: "clamp(40px, 6vw, 56px)",
      background: "linear-gradient(180deg, #23B35C 0%, #168547 100%)",
    }}
  >
    <Icon
      className="text-white"
      style={{
        width: "clamp(18px, 2.2vw, 28px)",
        height: "clamp(18px, 2.2vw, 28px)",
      }}
    />
  </div>
);

const ModuleItem: React.FC<{ m: Module }> = ({ m }) => (
  <div className="flex flex-col items-center min-w-0">
    <IconBubble Icon={m.icon} />
    <div
      className="mt-2 sm:mt-3 text-center w-full min-w-0"
      style={{ maxWidth: "210px" }} // thay vì width: clamp(...)
    >
      <p
        className="font-semibold tracking-[0.01em] truncate"
        style={{
          fontSize: "clamp(12px, 1.5vw, 15px)",
          lineHeight: 1.3,
        }}
      >
        {m.label}
      </p>
    </div>
  </div>
);

// ✅ Cố định 4 cột (luôn hàng 4) – không scroll nội bộ, nếu thiếu chỗ thì cuộn toàn trang
export const ModuleGrid: React.FC = () => {
  return (
    <div className="w-full">
      <div className="border rounded-md">
        <div className="bg-[#f5f6f7] text-[15px] font-medium px-3 py-1.5 rounded-t-md border-b">
          Quản trị hệ thống
        </div>

        <div className="px-3 sm:px-4 py-4 sm:py-6">
          <div
            className="grid place-items-center"
            style={{
              // Luôn 4 cột
              gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
              // Gap co giãn theo viewport (gọn trên mobile)
              rowGap: "clamp(16px, 2.2vw, 32px)",
              columnGap: "clamp(12px, 2.2vw, 28px)",
            }}
          >
            {modules.map((m) => (
              <ModuleItem key={m.id} m={m} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleGrid;
